import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Dispute({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.4999 10.7778H11.4999L10.9999 8.88889V6.66667H12.9999V8.88889L12.4999 10.7778Z"
        fill={iconColor}
      />
      <Path
        d="M12.7499 13.3333H11.2499V11.6667H12.7499V13.3333Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.99992 4C3.63173 4 3.33325 4.29848 3.33325 4.66667V15.3333C3.33325 15.7015 3.63173 16 3.99992 16H7.33325V20.6667C7.33325 20.9363 7.49568 21.1794 7.7448 21.2826C7.99391 21.3858 8.28066 21.3287 8.47132 21.1381L13.6094 16H19.9999C20.3681 16 20.6666 15.7015 20.6666 15.3333V4.66667C20.6666 4.29848 20.3681 4 19.9999 4H3.99992ZM4.66659 14.6667V5.33333H19.3333V14.6667H13.3333C13.1564 14.6667 12.9869 14.7369 12.8618 14.8619L8.66659 19.0572V15.3333C8.66659 14.9651 8.36811 14.6667 7.99992 14.6667H4.66659Z"
        fill={iconColor}
      />
    </Svg>
  );
}
